import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../../../../constants/axiosInstance';

type User = {
    _id: string;
    name: string;
    email: string;
    number: string;
    userStatus?: string;
    isStaff?: boolean;
    isArchived?: boolean;
    profilePic?: string;
};

type Asset = {
    _id: string;
    plantName: string;
    plantNickName?: string;
    abbr?: string;
    lat?: string;
    long?: string;
};

const fetchEscalationMetaData = async (userGroupId: string) => {
    const response = await axiosInstance().post('/escalation/getUserGroupDetails', {
        userGroupId,
    });
    return response.data;
};

export const useEscalationMetaData = (userGroupId: any) => {
    const { data, isLoading, error, isError, isSuccess, refetch } = useQuery({
        queryKey: ['escalationsMetaData', userGroupId],
        queryFn: () => fetchEscalationMetaData(userGroupId._id),
        enabled: !!userGroupId,
        retry: 1,
        refetchOnWindowFocus: false,

        select: (
            rawData
        ): {
            escalationUsers: User[];
            escalationAssets: Asset[];
        } => {
            const escalationUsers = rawData?.data?.userIds ?? [];
            const escalationAssets =
                rawData?.data?.workspaceAssets?.flatMap((ws: any) => ws.assetIds ?? []) ?? [];

            return {
                escalationUsers,
                escalationAssets,
            };
        },
    });

    return {
        escalationUsers: data?.escalationUsers ?? [],
        escalationAssets: data?.escalationAssets ?? [],
        isEscalationMetaDataLoading: isLoading,
        escalationMetaDataError: error,
        isEscalationMetaDataError: isError,
        isEscalationMetaDataSuccess: isSuccess,
        refetchEscalationMetaData: refetch,
    };
};
